import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEOHead from "@/components/SEOHead";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEOHead
        title="404 - Página no encontrada"
        description="La página que buscás no existe o fue movida."
        noIndex={true}
      />
      <Header />
      <div className="flex-1 flex items-center justify-center bg-muted">
        <div className="text-center px-4 space-y-6">
          <h1 className="text-8xl md:text-9xl font-bold text-primary">404</h1>
          <h2 className="text-2xl md:text-3xl font-bold">Página no encontrada</h2>
          <p className="text-muted-foreground max-w-md mx-auto">
            Lo sentimos, la página que buscás no existe o fue movida.
          </p>
          <Button asChild size="lg">
            <Link to="/">
              <Home className="mr-2" />
              Volver al Inicio
            </Link>
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
